<template>
    <v-menu v-model="menu" offset-y :max-height="maxHeight" :min-width="minWidth" :disabled="disabled">
        <template v-slot:activator="{ on, attrs }">
            <slot name="activator" :on="on" :attrs="attrs">
                <button type="button" class="hd-trigger" :class="{ 'hd-trigger--block': block }" v-bind="attrs" v-on="on">
                    <span class="text-truncate">{{ selectedText }}</span>
                    <v-icon size="16">mdi-chevron-down</v-icon>
                </button>
            </slot>
        </template>
        <v-list dense class="hd-list">
            <template v-for="(item, i) in items">
                <v-subheader v-if="item.header" :key="`h${i}`" class="hd-header">{{ item.header }}</v-subheader>
                <v-list-item v-else :key="`i${i}`" link :class="{ 'hd-item--used': item.used, 'hd-item--active': item.value === value }"
                    @click="$emit('change', item.value)">
                    <v-icon v-if="item.icon" size="16" class="mr-2 hd-icon">{{ item.icon }}</v-icon>
                    <v-list-item-title class="hd-text">{{ item.text }}</v-list-item-title>
                    <v-icon v-if="item.used" size="14" class="ml-2 hd-icon">mdi-check</v-icon>
                </v-list-item>
            </template>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: 'HabitDropdown',
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        value: {
            type: [String, Number],
            default: null,
        },
        placeholder: {
            type: String,
            default: '',
        },
        maxHeight: {
            type: [Number, String],
            default: 250,
        },
        minWidth: {
            type: [Number, String],
            default: 180,
        },
        block: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            menu: false,
        }
    },
    computed: {
        selectedText(vm = this) {
            const item = vm.items.find(it => !it.header && it.value === vm.value)
            return item ? (item.short || item.text) : vm.placeholder
        },
    },
}
</script>

<style scoped>
.hd-trigger {
    height: 34px;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    padding: 0 8px 0 10px;
    border-radius: 8px;
    border: 1px solid var(--v-outline-base);
    background: var(--v-surface2-base);
    color: var(--v-txtPrimary-base);
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: .02em;
    cursor: pointer;
    max-width: 100%;
    transition: border-color .15s;
}

.hd-trigger:hover {
    border-color: var(--v-outline2-base);
}

.hd-trigger--block {
    width: 100%;
    height: 40px;
}

.hd-trigger .v-icon {
    color: var(--v-txtMuted-base) !important;
}

.hd-list {
    background: var(--v-surface-base) !important;
}

.hd-header {
    height: 28px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .06em;
    color: var(--v-txtMuted-base) !important;
}

.hd-text {
    font-size: 12px !important;
}

.hd-icon {
    color: var(--v-accent-base) !important;
}

.hd-item--used {
    opacity: .45;
}

.hd-item--active .hd-text {
    color: var(--v-accent-base);
    font-weight: 600;
}
</style>
